import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { MobileLayout } from '../../components/MobileLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { ArrowLeft, MapPin, Clock, Home, User, Navigation } from 'lucide-react';
import { useMaintenance, JobStatus } from '../../context/MaintenanceContext';
const statusMap: Record<JobStatus, {
  label: string;
  cls: string;
}> = {
  da_accettare: {
    label: 'Da accettare',
    cls: 'bg-amber-50 text-amber-700 border-amber-200'
  },
  accettata: {
    label: 'Accettata',
    cls: 'bg-muted text-muted-foreground border-border'
  },
  in_corso: {
    label: '● In corso',
    cls: 'bg-coral/5 text-coral border-coral/20'
  },
  completata: {
    label: 'Completata',
    cls: 'bg-emerald-50 text-emerald-700 border-emerald-200'
  }
};
export function ManInterventoDettaglioPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const {
    jobs,
    acceptJob,
    startJob,
    completeJob
  } = useMaintenance();
  const job = jobs.find(j => j.id === id);
  if (!job) {
    return <MobileLayout data-id="element-2733">
        <Link to="/man/incarichi" className="flex items-center gap-1 text-sm text-muted-foreground hover:text-navy mb-6" data-id="element-2734">
          <ArrowLeft size={16} data-id="element-2735" />
          Incarichi
        </Link>
        <div className="bg-white border border-border rounded-xl p-10 text-center" data-id="element-2736">
          <p className="text-sm font-medium text-foreground" data-id="element-2737">
            Intervento non trovato
          </p>
        </div>
      </MobileLayout>;
  }
  const st = statusMap[job.status];
  const nextAction = () => {
    if (job.status === 'da_accettare') acceptJob(job.id);else if (job.status === 'accettata') startJob(job.id);else if (job.status === 'in_corso') completeJob(job.id);
  };
  const actionLabel = job.status === 'da_accettare' ? 'Accetta intervento' : job.status === 'accettata' ? 'Avvia intervento' : job.status === 'in_corso' ? 'Segna completato' : null;
  return <MobileLayout data-id="element-2738">
      <button onClick={() => navigate('/man/incarichi')} className="flex items-center gap-1 text-sm text-muted-foreground hover:text-navy mb-4 transition-colors" data-id="element-2739">
        <ArrowLeft size={16} data-id="element-2740" />
        Incarichi
      </button>

      <div className="flex items-start justify-between gap-3 mb-6" data-id="element-2741">
        <div data-id="element-2742">
          <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-2743">
            {job.title}
          </h1>
          <p className="text-sm text-muted-foreground mt-1" data-id="element-2744">
            {job.trade} · {job.type}
          </p>
        </div>
        <span className={`text-[11px] font-medium px-2.5 py-1 rounded-full border flex-shrink-0 ${st.cls}`} data-id="element-2745">
          {st.label}
        </span>
      </div>

      <Card className="mb-4" data-id="element-2746">
        <CardContent className="space-y-3" data-id="element-2747">
          <h3 className="text-xs uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-2748">
            Dettagli intervento
          </h3>
          <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-2749">
            <div className="flex items-center gap-2 text-foreground" data-id="element-2750">
              <Home size={14} className="text-muted-foreground" data-id="element-2751" />
              {job.property}
            </div>
            <div className="flex items-center gap-2 text-foreground" data-id="element-2752">
              <MapPin size={14} className="text-muted-foreground" data-id="element-2753" />
              {job.zone}
            </div>
            <div className="flex items-center gap-2 text-foreground" data-id="element-2754">
              <Clock size={14} className="text-muted-foreground" data-id="element-2755" />
              {job.date} · {job.time}
            </div>
            <div className="flex items-center gap-2 text-foreground" data-id="element-2756">
              <Navigation size={14} className="text-muted-foreground" data-id="element-2757" />a{' '}
              {job.distanceKm < 1 ? `${Math.round(job.distanceKm * 1000)} m` : `${job.distanceKm} km`}
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="mb-4" data-id="element-2758">
        <CardContent className="space-y-3" data-id="element-2759">
          <h3 className="text-xs uppercase tracking-wider font-semibold text-muted-foreground" data-id="element-2760">
            Host
          </h3>
          <div className="flex items-center gap-2 text-sm text-foreground" data-id="element-2761">
            <User size={14} className="text-muted-foreground" data-id="element-2762" />
            {job.hostName}
          </div>
        </CardContent>
      </Card>

      <Card className="mb-6" data-id="element-2763">
        <CardContent className="flex items-center justify-between" data-id="element-2764">
          <span className="text-sm text-muted-foreground" data-id="element-2765">Compenso</span>
          <span className="text-lg font-bold text-foreground" data-id="element-2766">
            €{job.earning}
          </span>
        </CardContent>
      </Card>

      {actionLabel && <Button className="w-full" onClick={nextAction} data-id="element-2767">
          {actionLabel}
        </Button>}
    </MobileLayout>;
}